	import { Http, Response } from '@angular/http';
import { Injectable } from '@angular/core';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

@Injectable()
export class PunchCardIconProvider {
 	url: any;
 	token: any;
 	icon: any = {
 		Id: 1,
 		IconPath: "weed-solo.png"
 	};

	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	) {
		console.log('Hello PunchCardIconProvider Provider');
	}

	reset(){
		this.icon = {
	 		Id: 1,
	 		IconPath: "weed-solo.png"
	 	};
	}

	getPunchCardIcons(params){	
	  	this.url = this.globals.dataUrl + 'businessPunchCard/whiskey/' + this.globals.whiskeyId + '/icons/v2/' +
										  '/page/' + params.page +
										  '/size/' + params.size +
										  '?term=' + params.term;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}

}



// WEBPACK FOOTER //
// ./src/providers/punch-card-icon.ts